'use client';

import dynamic from "next/dynamic";
import { TestimonialsSkeleton } from "@/components/sections/testimonials-skeleton";

const Testimonials = dynamic(() => import('@/components/sections/testimonials').then(mod => mod.Testimonials), {
    loading: () => <TestimonialsSkeleton />,
    ssr: false,
});

export function ClientTestimonials() {
    return <Testimonials />;
}
